import { useMemo } from 'react';
import { useAccountUsdDetails } from './useAccountUsdDetails';

// Hook for deriving token USD prices from the account usd-details payload.
export function useAccountTokenUsdPrices(accountId: string) {
  const { accountUsdDetails, isLoading, error, refresh } =
    useAccountUsdDetails(accountId);

  const tokenUsdPrices = useMemo(() => {
    if (!accountUsdDetails) {
      return [];
    }

    return accountUsdDetails.assets
      .map((asset) => ({
        contractTokenId: asset.contractTokenId,
        realUsdValue: asset.realUsdValue
          ? {
              price: asset.realUsdValue.price,
            }
          : null,
      }))
      .sort((a, b) => a.contractTokenId.localeCompare(b.contractTokenId));
  }, [accountUsdDetails]);

  return {
    tokenUsdPrices,
    isLoading,
    error,
    refresh,
  };
}
